module.exports = __webpack_public_path__ + "img/45-whrjgczy.71188ce9.png";